import React, { PureComponent, Fragment } from 'react';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import { Row, Col, Collapse, Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { number, object, array, func } from 'prop-types';
import { isURL } from 'validator';
import { streams } from '../../../../services/ApiService';
import Card from '../../../../components/Card/Card';
import FlowPostbackMethod from './FlowPostbackMethod';
import FlowPostbackUrl from './FlowPostbackUrl';
import FlowPostbackStatuses from './FlowPostbackStatuses';
import FlowPixels from '../../../../components/Flow/FlowPixels';
import AlertModal from '../../../../modals/AlertModal/AlertModal';
import { FMessage } from '../../../../hoc/IntlComponents';

class FlowPostback extends PureComponent {
    static propTypes = {
        pixels: array.isRequired,
        streamPixels: array.isRequired,
        statuses: array.isRequired,
        streamStatuses: array.isRequired,
        postback: object,
        streamId: number,
        onPostbackChange: func,
        onPixelChange: func,
        onStatusChange: func,
    };

    static defaultProps = {
        pixels: [],
        streamPixels: [],
        statuses: [],
        streamStatuses: [],
    };

    state = {
        loading: false,
        collapsed: true,
        modal: false,
        errorModal: false,
        postback: {
            method: 0,
            url: '',
        },
        response: '',
        error: '',
    };

    UNSAFE_componentWillReceiveProps(nextProps) {
        const { postback } = nextProps;

        if (postback) {
            this.setState(() => ({ postback }));
        }
    }

    togglePostback = () => {
        this.setState(prevState => ({ collapsed: !prevState.collapsed }));
    };

    toggleModal = () => {
        this.setState(prevState => ({ modal: !prevState.modal }));
    };

    toggleErrorModal = () => {
        this.setState(prevState => ({ errorModal: !prevState.errorModal }));
    };

    handlePostbackChange = data => {
        this.setState(
            prevState => ({
                postback: {
                    ...prevState.postback,
                    ...data,
                },
            }),
            () => {
                this.props.onPostbackChange(this.state.postback);
            },
        );
    };

    checkPostback = () => {
        const { postback } = this.state;

        this.setState(() => ({ loading: true }));

        streams
            .checkPostback(postback)
            .then(({ items }) => {
                const data = items[0];

                this.setState(() => ({
                    loading: false,
                    response: data.response,
                }));

                this.toggleModal();
            })
            .catch(({ response = {} }) => {
                if (response.data && response.data.error) {
                    const { message: error, code } = response.data.error;
                    if (code !== 429) {
                        this.setState(() => ({
                            errorModal: true,
                            error: error.message,
                            loading: false,
                        }));
                    } else {
                        this.setState(() => ({
                            loading: false,
                        }));
                    }
                }
            });
    };
    isValidUrl = url => isURL(url);

    render() {
        const { loading, postback, collapsed, modal, response, errorModal, error } = this.state;
        const { pixels, statuses, streamId, streamPixels, streamStatuses, className } = this.props;

        return (
            <Fragment>
                <Card loading={loading} className={className}>
                    <Card.Header>
                        <FormattedMessage id="flow.form.postback.title" defaultMessage="Postback URL" />
                    </Card.Header>
                    <Card.Body>
                        {/* Postback method and URL */}
                        <Row>
                            <Col lg="12">
                                <FlowPostbackUrl
                                    url={postback.url}
                                    onCheckPostback={this.checkPostback}
                                    onUrlChange={this.handlePostbackChange}
                                />
                            </Col>
                            <Col lg="12">
                                <FlowPostbackMethod
                                    method={postback.method}
                                    onPostbackMethodChange={this.handlePostbackChange}
                                />
                            </Col>
                        </Row>

                        {/* Postback goals and statuses */}
                        {pixels &&
                            statuses.length > 0 && (
                                <Fragment>
                                    {/* <Row>
                                        <Col>
                                            <Button
                                                className="dropdown-toggle"
                                                active={!collapsed}
                                                color="light"
                                                size="sm"
                                                onClick={this.togglePostback}
                                            >
                                                <FormattedMessage
                                                    id="flow.form.postback.settings"
                                                    defaultMessage="Settings"
                                                />
                                            </Button>
                                        </Col>
                                    </Row> */}

                                    <div className="postback-extra-settings">
                                        <Row>
                                            <Col xl="12" lg="12">
                                                <FlowPostbackStatuses
                                                    onStatusChange={this.props.onStatusChange}
                                                    statuses={statuses}
                                                    selected={streamStatuses}
                                                />
                                            </Col><Col lg={{ size: '10', offset: '2' }} xl={{ size: '10', offset: '2' }}>
                                                <FlowPixels
                                                    selected={streamPixels}
                                                    pixels={pixels}
                                                    onPixelChange={this.props.onPixelChange}
                                                />
                                            </Col>
                                        </Row>
                                    </div>
                                </Fragment>
                            )}
                        <Row>
                            <Col lg={{ size: '10', offset: '2' }}>
                                <Button
                                    type="button"
                                    color="primary"
                                    onClick={this.checkPostback}
                                    disabled={!this.isValidUrl(postback.url)}
                                >
                                    <FormattedMessage id="flow.form.postback.check" defaultMessage="Check Postback" />
                                </Button>
                            </Col>
                        </Row>
                    </Card.Body>
                    <Card.Footer>
                        <ul className="postback-links list-inline no-margin">
                            <li className="list-inline-item">
                                <Link to="/faq/tools/flows/postback">
                                    <FormattedMessage id="flow.form.postback.help" defaultMessage="Help" />
                                </Link>
                            </li>

                            {streamId && (
                                <li className="list-inline-item">
                                    <Link to={`/postback/${streamId}`}>
                                        <FormattedMessage id="flow.form.postback.logs" defaultMessage="Logs" />
                                    </Link>
                                </li>
                            )}

                            <li className="list-inline-item">
                                <Link to="/tools/global-postback">
                                    <FMessage id="postback.global.title" />
                                </Link>
                            </li>
                        </ul>
                    </Card.Footer>
                </Card>

                <Modal size="lg" isOpen={modal} toggle={this.toggleModal}>
                    <ModalHeader toggle={this.toggleModal}>
                        <FormattedMessage id="flow.modal.postback-response" defaultMessage="Postback reponse" />
                    </ModalHeader>
                    <ModalBody>
                        <pre>{response}</pre>
                    </ModalBody>
                </Modal>

                <AlertModal open={errorModal} message={error} onClose={this.toggleErrorModal} />
            </Fragment>
        );
    }
}

export default FlowPostback;
